import { setHidden } from './collapse.js';

// Buchungsformular (Templates/OfferBooking/Form.html, Development/offer-booking.md §5):
// blendet Felder je nach "Ich buche als" und Checkboxen ein/aus (weich animiert über
// collapse.js) und verwaltet die Personenblöcke "Weitere Teilnehmende". Ohne JavaScript
// bleibt der Stand des Servers sichtbar; geprüft wird ausschließlich serverseitig.
export function initOfferBooking() {
  const form = document.querySelector('form[data-booking-form]');
  if (!form) return;

  const customerTypeInputs = form.querySelectorAll('[data-booking-customer-type]');
  const participantSection = form.querySelector('[data-booking-section="participants"]');
  const participantList = form.querySelector('[data-booking-participants]');
  const template = form.querySelector('template[data-booking-participant-template]');
  const addButton = form.querySelector('[data-booking-add]');
  const max = Number(participantSection?.dataset.bookingMax || 10);

  // Neue Blöcke bekommen Indizes oberhalb der vom Server gerenderten
  let nextIndex = participantList ? participantList.querySelectorAll('[data-booking-participant]').length : 0;

  const isCorporate = () => form.querySelector('[data-booking-customer-type]:checked')?.value === 'corporate';

  const bookerParticipates = () =>
    form.querySelector('[data-booking-booker-participates]:checked')?.value !== '0';

  const updateCustomerType = (animate = true) => {
    const corporate = isCorporate();
    form.querySelectorAll('[data-booking-corporate]').forEach((element) => {
      setHidden(element, !corporate, { animate });
    });
    form.querySelectorAll('[data-booking-private]').forEach((element) => {
      setHidden(element, corporate, { animate });
    });
  };

  const updateParticipants = () => {
    if (!participantList) return;
    const blocks = participantList.querySelectorAll('[data-booking-participant]');
    // Mindestens ein Personenblock: beim letzten kein "Entfernen"
    blocks.forEach((block) => {
      const removeButton = block.querySelector('[data-booking-remove]');
      if (removeButton) removeButton.hidden = blocks.length <= 1;
    });
    if (addButton) {
      addButton.hidden = blocks.length + (bookerParticipates() ? 1 : 0) >= max;
    }
  };

  const addParticipant = () => {
    if (!template || !participantList) return;
    const html = template.innerHTML.replaceAll('__INDEX__', String(nextIndex));
    nextIndex += 1;
    participantList.insertAdjacentHTML('beforeend', html);
    const block = participantList.lastElementChild;
    // Neue Felder ohne Animation an den Kundentyp anpassen, danach den Block einblenden
    updateCustomerType(false);
    updateParticipants();
    if (block) {
      block.hidden = true;
      setHidden(block, false);
    }
    block?.querySelector('select, input')?.focus({ preventScroll: true });
  };

  customerTypeInputs.forEach((input) => input.addEventListener('change', () => updateCustomerType()));

  form.querySelectorAll('[data-booking-toggle]').forEach((checkbox) => {
    const section = form.querySelector(`[data-booking-section="${checkbox.dataset.bookingToggle}"]`);
    if (!section) return;
    checkbox.addEventListener('change', () => {
      setHidden(section, !checkbox.checked);
    });
  });

  form.querySelectorAll('[data-booking-booker-participates]').forEach((input) => {
    input.addEventListener('change', updateParticipants);
  });

  addButton?.addEventListener('click', addParticipant);

  participantList?.addEventListener('click', (event) => {
    const removeButton = event.target.closest('[data-booking-remove]');
    if (!removeButton) return;
    const block = removeButton.closest('[data-booking-participant]');
    if (!block) return;
    // Sofort aus der Zählung nehmen, aus dem DOM erst nach dem Ausblenden
    block.removeAttribute('data-booking-participant');
    block.querySelectorAll('input, select, textarea, button').forEach((field) => {
      field.disabled = true;
    });
    updateParticipants();
    addButton?.focus();
    setHidden(block, true, { onDone: () => block.remove() });
  });

  updateCustomerType(false);
  updateParticipants();

  // Nach Validierungsfehlern zum Hinweis springen (Fragment #booking-errors)
  const errorSummary = form.querySelector('#booking-errors');
  if (errorSummary && window.location.hash === '#booking-errors') {
    errorSummary.focus();
  }
}
